import { Space } from '@tribeplatform/gql-client/types'
import { SpaceImage } from '@tribeplatform/react-components/Space'
import { useRouter, useRouterPath } from '@tribeplatform/react-sdk'
import { useSpaceUtil } from '@tribeplatform/react-sdk/hooks'
import { NavVertical } from '@tribeplatform/react-ui-kit/Sidebar'

import { useSlate } from '../../hooks/slate.hook.js'
import { useMobileMenu } from '../Navbar/providers/MobileMenuProvider.js'

export const CollectionMenuSpaceItem = ({ space }: { space: Space }) => {
  const { Link } = useRouter()
  const { close } = useMobileMenu()
  const { generatePath, matchPath } = useSpaceUtil()
  const pathname = useRouterPath()
  const { mode } = useSlate()
  const isPreviewMode = mode !== 'live'
  const isActive = matchPath(space, pathname)

  // For any member of a locale group — primary or the locale-matching variant
  // this menu chose to display — link to the group base path; the backend
  // resolves it to the variant matching the member's locale. The displayed
  // space only drives the localized name/icon, not the link target.
  const { localeGroup } = space
  const href = localeGroup?.basePath
    ? generatePath({
        address: {
          path: localeGroup.basePath,
          exact: false,
          editable: false,
        },
      })
    : space?.relativeUrl

  return (
    <NavVertical.Item
      as={Link}
      href={href}
      active={!!isActive}
      leadingAddon={
        <div className="me-3 -ms-1">
          <SpaceImage space={space} size="lg" />
        </div>
      }
      onClick={e => {
        if (isPreviewMode) {
          e.preventDefault()
          return
        }

        close()
      }}
    >
      {space.name}
    </NavVertical.Item>
  )
}
